export default __webpack_public_path__ + "static/media/gallery-wip-denix-scope-mount-hole_04.93608086.jpg";